import React, {FC} from "react"

import authentication from "@irati/auth"
import Spacing from "@irati/ui/src/Spacing"
import MySavingsCard from "@irati-web/my-savings/src/components/SavingsTracker/Widgets/MySavings"
import MySavingsCalculator from "@irati-web/my-savings/src/components/MySavingsCalculator"

import ExpiryInformationBanner from "./ExpiryInformationBanner"
import AdsCarousel from "./AdsCarousel"
import Wallet from "./Wallet"
import Lanes from "./Lanes"

const Content: FC = () => {
  const showLanes = !authentication.apps("platform.homepageLanesHidden")

  return (
    <Spacing paddingBottom={5} style={{position: "relative"}}>
      <ExpiryInformationBanner />
      <MySavingsCard />
      {showLanes && (
        <>
          <Wallet />
          <MySavingsCalculator />
          <AdsCarousel />
          <Lanes />
        </>
      )}
    </Spacing>
  )
}

export default Content
